import React from 'react';

export const LandingPage: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#000000',
      backgroundImage: 'linear-gradient(to bottom, #000000 0%, #000000 62%, rgba(0,0,0,0) 92%), url(/sparks.jpg)',
      backgroundSize: '100% 100%, 100% auto',
      backgroundPosition: 'center top, center bottom',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      color: '#f0f0f0',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        padding: '48px 24px 32px',
        maxWidth: 900,
        width: '100%',
        textAlign: 'center',
      }}>
        <img
          src="/logo-orange.svg"
          alt="Lineup Foundry"
          style={{
            width: 'min(420px, 72vw)',
            height: 'min(420px, 72vw)',
            marginBottom: 56,
          }}
        />
        <img
          src="/hero_title.png"
          alt="Lineup Foundry"
          style={{
            width: 'min(448px, 62vw)',
            marginBottom: 72,
            objectFit: 'contain',
          }}
        />

        <a href="/download" style={{ display: 'inline-block', lineHeight: 0 }}>
          <img
            src="/download-on-the-app-store.svg"
            alt="Download on the App Store"
            style={{ height: 56, width: 'auto' }}
          />
        </a>

        <div style={{ marginTop: 64, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            color: '#888',
            fontSize: 14,
            letterSpacing: '0.02em',
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="#3DDC84"
            aria-hidden="true"
          >
            <path d="M17.6 9.48l1.84-3.18a.5.5 0 0 0-.87-.5l-1.86 3.22A11.3 11.3 0 0 0 12 8.2c-1.7 0-3.3.4-4.71.82L5.43 5.8a.5.5 0 1 0-.87.5l1.84 3.18C3.7 10.9 2 13.24 2 16h20c0-2.76-1.7-5.1-4.4-6.52zM6.5 13.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm11 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM5 17h14v2.5A1.5 1.5 0 0 1 17.5 21h-11A1.5 1.5 0 0 1 5 19.5V17z" />
          </svg>
          Android version coming soon
        </div>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const form = e.target as HTMLFormElement;
            const email = (form.elements.namedItem('email_address') as HTMLInputElement).value;
            try {
              await fetch('https://app.kit.com/forms/9939367/subscriptions', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email_address: email }),
              });
              form.innerHTML = '<span style="color:#EF9F27;font-size:13px">Great! You\'ll get an email when the Android version is available.</span>';
            } catch {
              form.innerHTML = '<span style="color:#888;font-size:13px">Something went wrong. Email us at jack@lineupfoundry.com</span>';
            }
          }}
          style={{ marginTop: 8, display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}
        >
          <input
            type="email"
            name="email_address"
            placeholder="your@email.com"
            required
            style={{
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid #444',
              borderRadius: 8,
              padding: '8px 14px',
              fontSize: 13,
              color: '#f0f0f0',
              outline: 'none',
              width: 200,
            }}
          />
          <button
            type="submit"
            style={{
              background: 'transparent',
              border: '1px solid #EF9F27',
              borderRadius: 8,
              padding: '8px 16px',
              fontSize: 13,
              color: '#EF9F27',
              cursor: 'pointer',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            Notify me
          </button>
        </form>
        </div>
      </div>

      <div style={{
        padding: '24px',
        width: '100%',
        textAlign: 'center',
        fontSize: 12,
        color: '#555',
      }}>
        <a href="/privacy" style={{ color: '#666', textDecoration: 'none', marginRight: 16 }}>Privacy Policy</a>
        <a href="mailto:jack@lineupfoundry.com" style={{ color: '#666', textDecoration: 'none' }}>Contact</a>
      </div>
    </div>
  );
};
